import { FC, useContext, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  Typography,
  useMediaQuery,
} from "@material-ui/core";
import { useTheme } from "@material-ui/core";
import cross from "../../assets/images/cross.svg";
import useStyles from "../Styles/ProjectModalStyles";
import { RelockGainsModalProps } from "../../interfaces";
import WalletContext from "../../store/Wallet/WalletContext";
import SubscriptionContext from "../../store/Subscription/SubscriptionContext";
import AlertContext from "../../store/Alert/AlertContext";
import { ChainFromNetworkId } from "../../store/Wallet/WalletFunction";
import { useAccount, useConfig } from "wagmi";
import { switchChain } from "@wagmi/core";
import { useWalletConnect } from "../../services/web3/hooks/useWeb3";

const RelockGainsModal: FC<RelockGainsModalProps> = ({
  open,
  setOpen,
  subscriptionId,
  duration,
  amount,
  tickets,
  address,
  network,
  scVersion,
}) => {
  const theme = useTheme();
  const config = useConfig();
  const isActive = useMediaQuery(theme.breakpoints.down("sm"));

  const { relockGains } = useContext<any>(WalletContext);
  const { totalTickets, getUserSubscriptions } = useContext<any>(SubscriptionContext);
  const { setAlert } = useContext<any>(AlertContext);
  const classes = useStyles();
  const { address: account, chain } = useAccount();
  const { openConnectModal } = useWalletConnect();

  const lockChainId = ChainFromNetworkId(network);
  const [inProgress, toggleInProgress] = useState(false);

  const handleRelock = async () => {
    if (!account && openConnectModal) {
      openConnectModal();
      return;
    }
    if (!lockChainId) {
      toggleInProgress(false);
      setAlert("Unable to perform the action at the moment, please try again", "info");
      return
    }
    toggleInProgress(true);
    if (lockChainId !== chain?.id) {
      await switchChain(config, {
        chainId: lockChainId
      })
    }
    relockGains(lockChainId, address.toLowerCase(), subscriptionId, scVersion)
      .then((data: any) => {
        console.log(data);
        getUserSubscriptions();
        setOpen(false);
        toggleInProgress(false);
      })
      .catch((error: any) => {
        toggleInProgress(false);
      });
  };

  const handleClose = (event: any, reason?: any) => {
    if ((reason && reason === "backdropClick") || inProgress) return;
    setOpen(false);
  };

  return (
    <>
      <Box component="section">
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          className={classes.modalpages}
        >
          <Box
            ml={isActive ? "20px" : 7}
            my={isActive ? "20px" : 7}
            mr={isActive ? "20px" : 4}
            className="relative-box"
          >
            <img
              src={cross}
              alt=""
              className="cross-icon"
              onClick={handleClose}
            />
            <Box mb={2} p={0}>
              <Typography variant="h2" color="primary">
                Relock
                <Typography component="span" variant="h2" color="secondary">
                  {" "}
                  GAINS
                </Typography>{" "}
                For <br /> {duration}{" "}
                {Number(duration) === 1 ? "Month" : "Months"}
              </Typography>{" "}
              {/** typegrapic box */}
            </Box>
            <Box>
              <Typography variant="body1" className="c-text">
                Right now you have
                <Typography
                  color="primary"
                  className="fw-bold"
                  component="span"
                >
                  {" "}
                  {totalTickets} {totalTickets === 1 ? "Ticket" : "Tickets"}
                </Typography>{" "}
                available, you would get
                <Typography
                  color="primary"
                  className="fw-bold"
                  component="span"
                >
                  {" "}
                  {tickets} {Number(tickets) === 1 ? "Ticket" : "Tickets"}
                </Typography>{" "}
                more by re-locking all your unlocked
                <Typography
                  color="primary"
                  className="fw-bold"
                  component="span"
                >
                  {" "}
                  {amount} GAINS
                </Typography>{" "}
                for {duration} {Number(duration) === 1 ? "month" : "months"}{" "}
                again.
              </Typography>
            </Box>

            <Box mt={isActive ? 3 : 5}>
              <Button
                variant="contained"
                color="secondary"
                className="responsive-btn"
                onClick={handleRelock}
                disabled={(account && account.toLowerCase() !== address.toLowerCase()) || inProgress }
              >
                {
                  (account)
                    ? (account.toLowerCase() !== address.toLowerCase())
                      ? "Incorrect Wallet"
                      : (lockChainId !== chain?.id)
                        ? "Switch Network"
                        : (inProgress)
                            ? "Relocking in Progress..."
                            : "Continue to Relock"
                    : "Connect wallet to relock"
                }
              </Button>
            </Box>
          </Box>
        </Dialog>
      </Box>
    </>
  );
};

export default RelockGainsModal;
